import { render, staticRenderFns } from "./psurvey-widget.vue?vue&type=template&id=121d8dea&"
import script from "./psurvey-widget.vue?vue&type=script&lang=js&"
export * from "./psurvey-widget.vue?vue&type=script&lang=js&"
import style0 from "./psurvey-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports